// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"Modal_closeButton__36FJn"};